import { render, staticRenderFns } from "./SeoDetay.vue?vue&type=template&id=1cb098a6&scoped=true&"
import script from "./SeoDetay.vue?vue&type=script&lang=js&"
export * from "./SeoDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb098a6",
  null
  
)

export default component.exports